import { css } from 'emotion'
// import { BORDER_RADIUS } from 'constants/styleConstants'

export const lightBoxStyles = css`
  padding: 16px;
  background-color: white;
`
